/*
Use this file to import custom js files from assets-extend/js or npm packages

Example:
import "./js/navigation-desktop.js";
*/
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

import './js/blog.js';
import './js/global.js';
import './js/cart.js';












